/* eslint-disable import/prefer-default-export */
import React from "react";
import { getDisplayName } from "../../../../utilities/utils";

const styles = {
  textStyle: {
    fontWeight: "normal",
    color: "red",
    fontSize: 14,
    fontFamily: "Arial"
  }
};
export const MissedMeeting = props => {
  const eventName = "scrum event";
  const worker = props.properties.find(p => p.itemKey === "worker").itemValue;

  const reason = props.properties.find(p => p.itemKey === "reason").itemValue;
  let topic = "";
  if (props.properties.filter(p => p.itemKey === "topic").length > 0) {
    topic = props.properties.find(p => p.itemKey === "topic").itemValue;
  }

  return (
    <div style={{ display: "flex", justifyContent: "left" }}>
      <span style={styles.textStyle}>
        {worker} {reason} {getDisplayName(topic)} {eventName}.
        <br />
        <br />
      </span>
    </div>
  );
};
